import React from 'react'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'hljd'
import Operation from '@common/Operation'
import store from '../store'
import { getObjValue, getMoney } from '@hlj/hlj-utils'
import { INVOICE_STATUS, INVOICE_COLOR } from '@constant'
import style from '../style.module.less'

const Item = Operation.Item

const data = [
  {
    label: '待开票',
    text: '尚未申请开发票'
  },
  {
    label: '申请中',
    text: '财务人员正在对发票进行审核'
  },
  {
    label: '审核不通过',
    text: '未通过财务人员的审核'
  },
  {
    label: '已开票',
    text: '发票已经开票成功，电子发票可通过手机短信下载，纸质发票正在配送中'
  }
]

const TP = ({ list }) => (
  <div>
    {list.map(({ label, text }, index) => (
      <p key={index} className={style.row}>
        <span className={style.tooltip_label}>{label}：</span>
        <span className={style.tooltip_text}>{text}</span>
      </p>
    ))}
  </div>
)

export default () => [
  {
    title: '订单号',
    dataIndex: 'trade_no'
  },
  {
    title: '创建时间',
    dataIndex: 'created_at'
    // render: created_at => {
    //   return (
    //     <div>
    //       <p>{(created_at || '').split(' ')[0]}</p>
    //       <p>{(created_at || '').split(' ')[1]}</p>
    //     </div>
    //   )
    // }
  },
  {
    title: '渠道',
    dataIndex: 'channel',
    render: channel => (channel == 1 ? '线上下单' : '线下创建')
  },
  {
    title: '产品名称',
    dataIndex: 'order_subs',
    render: order_subs => {
      return (
        <div>
          {(order_subs || []).map(({ id, product }) => (
            <p key={id}>{getObjValue(product, 'title')}</p>
          ))}
        </div>
      )
    }
  },
  {
    title: '订单金额',
    dataIndex: 'actual_money',
    render: actual_money => getMoney(actual_money)
  },
  {
    title: '可开票金额',
    dataIndex: 'paid_money',
    render: (paid_money, { invoice_status }) => {
      return (
        <p>
          {invoice_status == 2 || invoice_status == 4 ? (
            <span>-</span>
          ) : (
            <span style={{ color: '#FF9900' }}>{getMoney(paid_money)}</span>
          )}
        </p>
      )
    }
  },
  {
    title: '支付时间',
    dataIndex: 'pay_time'
  },
  {
    title: (
      <Tooltip title={<TP list={data} />}>
        开票状态 <QuestionCircleOutlined />
      </Tooltip>
    ),
    dataIndex: 'invoice_status',
    render: invoice_status => (
      <span style={{ color: INVOICE_COLOR[invoice_status + ''] }}>
        {INVOICE_STATUS[invoice_status + '']}
      </span>
    )
  },
  {
    title: '操作',
    dataIndex: 'operation',
    render: (o, record) => {
      const { id, from_pixiu, invoice_status } = record
      return (
        <Operation>
          {(invoice_status == 1 || invoice_status == 3) && (
            <Item onClick={() => store.openApplyModal(record)}>申请开票</Item>
          )}

          {invoice_status != 1 && (
            <Item onClick={() => store.openDetailModal(id, from_pixiu)}>
              详情
            </Item>
          )}
        </Operation>
      )
    }
  }
]
